import { render, staticRenderFns } from "./Succeed.vue?vue&type=template&id=008b86d8&"
import script from "./Succeed.vue?vue&type=script&lang=js&"
export * from "./Succeed.vue?vue&type=script&lang=js&"
import style0 from "./Succeed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports